// FlashMessageContext.js
import React, { createContext, useState } from 'react';

export const FlashMessageContext = createContext();

export const FlashMessageProvider = ({ children }) => {
  const [message, setMessage] = useState('');

  return (
    <FlashMessageContext.Provider value={{ message, setMessage }}>
      {children}
    </FlashMessageContext.Provider>
  );
};
